import { addGraphicState, removeGraphicState } from "../../util/graphic-state";

export const addRuntimeState = (g, stateName, attrs, keepCurrentStates = !0, hasAnimation) => {
    g.runtimeStateCache || (g.runtimeStateCache = {}), g.runtimeStateCache[stateName] = attrs, 
    g.hasState(stateName) && removeGraphicState(g, stateName), addGraphicState(g, stateName, keepCurrentStates, hasAnimation);
};
//# sourceMappingURL=glyph.js.map
